/* @flow */
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import ReactPhoneInput from 'react-phone-input-2'
import Select from 'react-select'
import Rating from 'react-rating'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faStar from '@fortawesome/fontawesome-free-regular/faStar'
import faFullStar from '@fortawesome/fontawesome-free-solid/faStar'
import moment from 'moment'
import _ from 'lodash'

import './style.css'
import Button from '../../components/Button'
import Radio from '../../components/Radio'
import ListItem from '../../components/ListItem'
import Card from '../../components/Card'
import Preview from '../../components/Preview'
import { genders, divingExps, BASE_URL } from '../../configs/constants'
import { updateAccount, search, showAlert, forgotPassword } from '../../actions/global'
import { setCurrentOrder, getOrders, cancelOrder } from '../../actions/order'
import { writeComment } from '../../actions/activity'
import { removeFavorite } from '../../actions/shop'
import { getAccountCoupons } from '../../actions/discount'
import { cancelPayment } from '../../libs/api'
// import IDCheck from '../../libs/pidCheck'
import Header from '../../components/Header'

class Account extends React.Component {
  idTypes

  constructor(props) {
    super(props)
    this.state = (props.account && { ...props.account, tab: 1 }) || {}
    if (props.account) {
      this.props.getOrders(this.props.account.email)
    }

    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleRadioOnChange = this.handleRadioOnChange.bind(this)
  }

  componentDidUpdate() {
    const { account, getOrders, getCoupons, messages } = this.props
    if (account && _.isEmpty(this.state)) {
      getOrders(account.email)
      getCoupons(account.uid)
      this.setState({
        ...account,
        tab: 1,
        idType: this.idTypes[0],
        messageFilter: 'all',
        divingExperience: 0,
        divingLicense: false,
      })
    }
    if (messages.length && !this.state.filteredMessages) {
      this.setState({
        filteredMessages: messages,
      })
    }
  }

  onSubmit(event) {
    event.preventDefault()
  }

  handleRadioOnChange(value) {
    this.setState({
      divingLicense: value
    })
  }
  handleOnChange(value) {
    this.setState({
      phoneNumber: value
    })
  }

  handleRatingOnChange(value, field) {
    const rating = {}
    rating[field] = value
    this.setState(rating)
  }

  onMessageFilterChange(allMessages, type) {
    const messages = type === 'all' ? allMessages : _.filter(allMessages, { type })
    this.setState({
      messageFilter: type,
      filteredMessages: messages
    })
  }

  renderOrder = (order, key, props, state) => {
    const {
      locale,
      navigate,
      shops,
      account,
      showAlert,
      setCurrentOrder,
      cancelOrder,
      writeComment,
    } = props
    const {
      // Rating
      whole,
      profession,
      service,
      comfort,
      value,
      commentTitle,
      commentContent,
    } = state
    const shop = _.find(shops, { id: order.shopId })

    return <ListItem key={key} className={order.status}>
      <Preview
        imageOnLeft
        locale={locale}
        subtitle={shop.name[locale]}
        data={order}
        onHeaderClick={(e) => {
          navigate('/shop/' + order.shopId)
        }}
        options={[{
          title: 'date',
          value: moment(order.startDate).format('YYYY-MM-DD') + ' ' + (order.timeSection ? (order.timeSection.label || order.timeSection) : '')
        }, {
          title: 'orderNo',
          value: order.id
        }]}
        footer={[{
          isButton: true,
          title: I18n.t('orderDetail'),
          onClick: (e) => {
            setCurrentOrder(order)
            navigate('/orders/' + order.orderNo)
          }
        }, {
          isButton: true,
          title: order.comment ? I18n.t('yourComment') : I18n.t('writeComment'),
          isToggleExpand: true,
          hideWhen: moment().isBefore(moment(order.endDate), 'day'),
        }, {
          isButton: true,
          title: I18n.t('payNow'),
          hideWhen: order.status !== 'unpaid' || moment().isSameOrAfter(moment(order.endDate), 'day'),
          onClick: (e) => {
            const newWindow = window.open(`${BASE_URL}/orders/${order.orderNo}`)
            newWindow.onbeforeunload = function() {
              window.location.reload()
            }
          }
        }, {
          isButton: true,
          title: I18n.t('cancelOrder'),
          hideWhen: moment().isAfter(moment(order.startDate), 'day') || order.status === 'cancelled',
          onClick: (e) => {
            if (order.status === 'paid') {
              const diffDays = moment(order.startDate).diff(moment(), 'days')
              if (diffDays === 1) {
                // TODO: return 50%
              } else if (diffDays > 1 && diffDays < 7) {
                // TODO: return 70%
              } else {
                showAlert(
                  I18n.t('orderNo') + ' ' + order.orderNo + '<br />總金額 ' + (order.totalAmount - (order.discount ? order.discount : 0)) + '<br />' + I18n.t('confirmCancelOrder'),
                  I18n.t('cancelOrder'),
                  'warning',
                  true,
                  () => {
                    cancelPayment(new Date().getTime(), order.orderNo, order.totalAmount - (order.discount ? order.discount : 0)).then((response) => {
                      if (response.Status === 'SUCCESS') {
                        cancelOrder(order)
                      }
                    })
                  }
                )
              }
            } else {
              showAlert(
                I18n.t('orderNo') + ' ' + order.orderNo + '<br />總金額 ' + (order.totalAmount - (order.discount ? order.discount : 0)) + '<br />' + I18n.t('confirmCancelOrder'),
                I18n.t('cancelOrder'),
                'warning',
                true,
                () => cancelOrder(order)
              )
            }
          }
        }, {
          isButton: true,
          title: I18n.t('reOrder'),
          hideWhen: moment().isBefore(moment(order.endDate), 'day'),
          onClick: (e) => navigate('/activity/' + order.activityId)
        }]}
        expandable
        expandContent={
          <form onSubmit={this.onSubmit}>
            <Header title="yourComment" />
            <Card>
              <label>
                <Translate className="label" value="whole" />
                <Rating
                  readonly={!!order.comment}
                  onChange={(value) => this.handleRatingOnChange(value, 'whole')}
                  emptySymbol={<FontAwesomeIcon size="lg" icon={faStar} color="#009999" />}
                  fullSymbol={<FontAwesomeIcon size="lg" icon={faFullStar} color="#009999" />}
                  initialRating={whole || (order.comment && order.comment.whole)} />
              </label>
              <label>
                <Translate className="label" value="profession" />
                <Rating
                  readonly={!!order.comment}
                  onChange={(value) => this.handleRatingOnChange(value, 'profession')}
                  emptySymbol={<FontAwesomeIcon size="lg" icon={faStar} color="#009999" />}
                  fullSymbol={<FontAwesomeIcon size="lg" icon={faFullStar} color="#009999" />}
                  initialRating={profession || (order.comment && order.comment.profession)} />
              </label>
              <label>
                <Translate className="label" value="service" />
                <Rating
                  readonly={!!order.comment}
                  onChange={(value) => this.handleRatingOnChange(value, 'service')}
                  emptySymbol={<FontAwesomeIcon size="lg" icon={faStar} color="#009999" />}
                  fullSymbol={<FontAwesomeIcon size="lg" icon={faFullStar} color="#009999" />}
                  initialRating={service || (order.comment && order.comment.service)} />
              </label>
              <label>
                <Translate className="label" value="comfort" />
                <Rating
                  readonly={!!order.comment}
                  onChange={(value) => this.handleRatingOnChange(value, 'comfort')}
                  emptySymbol={<FontAwesomeIcon size="lg" icon={faStar} color="#009999" />}
                  fullSymbol={<FontAwesomeIcon size="lg" icon={faFullStar} color="#009999" />}
                  initialRating={comfort || (order.comment && order.comment.comfort)} />
              </label>
              <label>
                <Translate className="label" value="value" />
                <Rating
                  readonly={!!order.comment}
                  onChange={(value) => this.handleRatingOnChange(value, 'value')}
                  emptySymbol={<FontAwesomeIcon size="lg" icon={faStar} color="#009999" />}
                  fullSymbol={<FontAwesomeIcon size="lg" icon={faFullStar} color="#009999" />}
                  initialRating={value || (order.comment && order.comment.value)} />
              </label>
              <div className="row">
                <Translate className="label" value="title" />
                <input value={commentTitle || (order.comment && order.comment.title)}
                  onChange={(e) => this.setState({ commentTitle: e.target.value })}
                  readOnly={!!order.comment}
                />
              </div>
              <div className="row">
                <Translate className="label" value="content" />
                <textarea value={commentContent || (order.comment && order.comment.content)}
                  onChange={(e) => this.setState({ commentContent: e.target.value })}
                  readOnly={!!order.comment}
                />
              </div>
            </Card>
            { order.comment ? null : <div>
              <Button type="action"
                text={I18n.t('sendComment')}
                onClick={(e) => {
                  console.log('send Comment')
                  writeComment({
                    orderId: order.id,
                    activityId: order.activityId,
                    creatorName: account.displayName,
                    creator: account.email,
                    whole, profession, service, comfort, value,
                    commentTitle, commentContent,
                  })
                }}
              />
              <Button type="action"
                text={I18n.t('cancel')}
                onClick={(e) => this.setState({
                  whole: 0,
                  profession: 0,
                  service: 0,
                  comfort: 0,
                  value: 0,
                  commentTitle: '',
                  commentContent: '',
                })}
              />
            </div>
            }
          </form>
        }
      />
    </ListItem>
  }

  render() {
    const {
      locale,
      updateAccount,
      changePassword,
      navigate,
      shops,
      account,
      orders,
      messages,
      removeFavorite,
      coupons,
    } = this.props
    const {
      id,
      idType,
      // isIdValid,
      firstName,
      lastName,
      displayName,
      gender,
      birthday,
      phoneNumber,
      email,
      divingLicense,
      divingExperience,
      tab,
      favorites,
      messageFilter,
      viewMessageId,
      filteredMessages,
    } = this.state

    let displayContent = null
    this.idTypes = [
      { label: I18n.t('id'), value: 'id' },
      { label: I18n.t('passport'), value: 'passport' },
    ]

    switch (tab) {
      case 2:
        const { cancelled, unconfirm, unpaid, paid } = _.groupBy(orders, 'status')
        const unconfirmSorted = _.sortBy(unconfirm, 'startDate')
        const unpaidSorted = _.sortBy(unpaid, 'startDate')
        const paidSorted = _.sortBy(paid, 'startDate')
        displayContent = <div>
          <Header title="unconfirm" />
          {_.map(unconfirmSorted, (order, key) => this.renderOrder(order, key, this.props, this.state))}
          <Header title="unpaid" />
          {_.map(unpaidSorted, (order, key) => this.renderOrder(order, key, this.props, this.state))}
          <Header title="paid" />
          {_.map(paidSorted, (order, key) => this.renderOrder(order, key, this.props, this.state))}
          <Header title="cancelled" />
          {_.map(cancelled, (order, key) => this.renderOrder(order, key, this.props, this.state))}
        </div>
        break
      case 3:
        displayContent = <div className="message-container">
          <Header title="filter" />
          <form>
            <ul>
              <li>
                <Radio name="messageType"
                  value="all"
                  selected={messageFilter}
                  onChange={(value) => this.onMessageFilterChange(messages, value)}
                />
                <Translate value="allMessages" />
              </li>
              <li>
                <Radio name="messageType"
                  value="order"
                  selected={messageFilter}
                  onChange={(value) => this.onMessageFilterChange(messages, value)}
                />
                <Translate value="orderMessages" />
              </li>
              <li>
                <Radio name="messageType"
                  value="activity"
                  selected={messageFilter}
                  onChange={(value) => this.onMessageFilterChange(messages, value)}
                />
                <Translate value="activityQuestions" />
              </li>
              <li>
                <Radio name="messageType"
                  value="system"
                  selected={messageFilter}
                  onChange={(value) => this.onMessageFilterChange(messages, value)}
                />
                <Translate value="systemNotification" />
              </li>
            </ul>
          </form>
          {_.map(filteredMessages, (message, key) =>
            {
              let shop
              if (message.shopId) {
                shop = _.find(shops, { id: message.shopId })
              }
              return <div key={key} className={'message-card ' + ((viewMessageId === key) && 'open')}>
                <div className="content">
                  <label>
                    <Translate value="date" />
                    <div className="value">{moment(message.createdTime).format('YYYY/MM/DD')}</div>
                  </label>
                  <label>
                    <Translate value="subject" />
                    <div className="value">{message.title}</div>
                  </label>
                  <div className="accordion-content">
                    <label>
                      <Translate value="message" />
                      <div className="value">{message.message}</div>
                    </label>
                    <label>
                      <Translate value="sender" />
                      <div className="value">{message.creator === account.displayName ? I18n.t('you') : message.creator}</div>
                    </label>
                    <label>
                      <Translate value="type" />
                      <div className="value">{I18n.t(message.type)}</div>
                    </label>
                    { message.type === 'activity' ? <label>
                      <Translate value="activityName" />
                      <div className="value">{message.activityName}</div>
                    </label> : null }
                    { message.shopId ? 
                      <label>
                        <Translate value="shop" />
                        <div className="value">{shop.name[locale]}</div>
                      </label> : null }
                  </div>
                </div>
                <div className="action">
                  <Button type="action"
                    text={viewMessageId === key ? I18n.t('close') : I18n.t('view')}
                    onClick={(e) => this.setState({ viewMessageId: (viewMessageId === key ? null : key) })}
                  />
                </div>
              </div>
            }
          )}
        </div>
        break
      case 4:
        displayContent = <div className="favorite">
          {_.map(favorites, (favorite, key) => {
            const shop = _.find(shops, { id: favorite.shopId })
            return <ListItem key={shop.id}>
              <Preview
                subtitle={shop.location}
                locale={locale}
                data={shop}
                hasLocation
                // showIntro
                options={[{
                  title: 'address',
                  value: shop.address[locale]
                }]}
                footer={[{
                  isButton: true,
                  title: I18n.t('detail'),
                  onClick: (e) => {
                    e.preventDefault()                      
                    e.stopPropagation()
                    navigate('/shop/' + shop.id)
                  }
                }, {
                  isButton: true,
                  type: 'danger',
                  title: I18n.t('removeFavorite'),
                  onClick: (e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    removeFavorite({ key, account })
                  }
                }]}
                onLocationClick={e => {
                  this.props.search(shop.location)
                  this.props.navigate('/map')
                  e.preventDefault()
                  e.stopPropagation()
                }}
              />
            </ListItem>
          })}
        </div>
        break
      case 5:
        displayContent = <div className="message-container">
          <Header title="coupons" />
          <ul>
            { _.map(_.flatMap(coupons, (event) => event), (coupon) =>
              <div key={coupon.code} className={'message-card'}>
                <div className="content">
                  <label>
                    <Translate value="amount" />
                    <div className="value">{coupon.amount}</div>
                  </label>
                  <label>
                    <Translate value="couponCode" />
                    <div className="value">{coupon.code}</div>
                  </label>
                  <label>
                    <Translate value="activatedPeriod" />
                    <div className="value">
                    {
                      [
                        moment(coupon.activatedDate).format('YYYY-MM-DD'),
                        moment(coupon.expiredDate).format('YYYY-MM-DD')
                      ].join(' - ')
                    }
                    </div>
                  </label>
                  <label>
                    <Translate value="used" />
                    <div className="value">
                    {
                      !coupon.active ? I18n.t('yes') : I18n.t('no')
                    }
                    </div>
                  </label>
                </div>
              </div>
            )}
          </ul>
        </div>
        break
      case 1:
      default:
        const divingExpList = _.map(divingExps, (exp) => ({
          ...exp,
          label: I18n.t(exp.label),
        }))
        displayContent = <Card>
          <form onSubmit={this.onSubmit}>
            <div className="info">
              <div className="info-row">
                <Translate value="idOrPassport" className="label" />
                <Select
                  className="select-front"
                  clearable={false}
                  name="fIDTypes"
                  value={idType}
                  onChange={(selected) => this.setState({ idType: selected })}
                  options={this.idTypes} />
                <div className='input'>
                  <input placeholder={I18n.t('idOrPassport')}
                    value={id}
                    onChange={(event) => {
                      const id = event.target.value
                      if ( this.state.idType === this.idTypes[0]) {
                        this.setState({
                          id,
                          // isIdValid: IDCheck(id)
                        })
                      } else {
                        this.setState({
                          id,
                          // isIdValid: (id.length < 20)
                        })
                      }
                    }}
                  />
                  {/* { isIdValid ? null : <Translate value="invalidNumber" className="danger" /> } */}
                </div>
              </div>
              <div className="info-row">
                <Translate value="displayName" className="label" />
                <div className="input">
                  <input placeholder={I18n.t('displayName')}
                    value={displayName}
                    onChange={(event) => this.setState({ displayName: event.target.value })}
                  />
                </div>
              </div>
              <div className="info-row">
                <Translate value="realName" className="label" />
                <div className="input input-group">
                  <input placeholder={I18n.t('firstName')}
                    value={firstName}
                    onChange={(event) => this.setState({ firstName: event.target.value })}
                  />
                  <input placeholder={I18n.t('lastName')}
                    value={lastName}
                    onChange={(event) => this.setState({ lastName: event.target.value })}
                  />
                </div>
              </div>
              <div className="info-row">
                <Translate value="gender" className="label" />
                <Select
                  clearable={false}
                  name="fGender"
                  value={_.find(genders, (option) => option.value === gender)}
                  onChange={(selected) => this.setState({ gender: selected.value })}
                  options={genders} />
              </div>
              <div className="info-row">
                <Translate value="birthday" className="label" />
                <div className='input'>
                  <input type="date"
                    value={birthday}
                    onChange={(event) => this.setState({ birthday: event.target.value })}
                  />
                </div>
              </div>
              <div className="info-row">
                <Translate value="contactPhone" className="label" />
                <ReactPhoneInput
                  value={phoneNumber}
                  defaultCountry={'tw'}
                  onChange={this.handleOnChange}
                  placeholder={I18n.t('contactPhone')}
                />
              </div>
              <div className="info-row">
                <Translate value="email" className="label" />
                <div className="input"><input placeholder="input value" value={email} disabled /></div>
              </div>
              <div className="info-row">
                <Translate value="divingLicense" className="label" />
                <div className="input radio-check">
                  <label>
                    <Radio
                      name="license"
                      checked={divingLicense}
                      onChange={this.handleRadioOnChange} />
                    <Translate value="have" className="label" />
                  </label>
                  <label>
                    <Radio
                      name="license"
                      checked={!divingLicense}
                      onChange={this.handleRadioOnChange}
                    />
                    <Translate value="haveNone" className="label" />
                  </label>
                </div>
              </div>
              <div className="info-row">
                <Translate value="divingExperience" className="label" />
                <Select
                  name="fDivingExp"
                  clearable={false}
                  value={_.find(divingExpList, (option) => option.value === divingExperience)}
                  onChange={(selected) => this.setState({ divingExperience: selected.value })}
                  options={divingExpList} />
              </div>
            </div>
          </form>
        </Card>
        break
    }
    
    return (<div className="account-container">
      <div className="menu">
        <div className={'menu-item' + (tab === 1 ? ' active' : '')} onClick={() => this.setState({ tab: 1 })}><Translate value="accountInfo" /></div>
        <div className={'menu-item' + (tab === 2 ? ' active' : '')} onClick={() => this.setState({ tab: 2 })}><Translate value="yourOrder" /></div>
        <div className={'menu-item' + (tab === 3 ? ' active' : '')} onClick={() => this.setState({ tab: 3 })}><Translate value="yourMessage" /></div>
        <div className={'menu-item' + (tab === 4 ? ' active' : '')} onClick={() => this.setState({ tab: 4 })}><Translate value="yourFavorite" /></div>
        <div className={'menu-item' + (tab === 5 ? ' active' : '')} onClick={() => this.setState({ tab: 5 })}><Translate value="coupons" /></div>
      </div>
      { displayContent }
      { tab === 1 ? <div className="footer">
        <Button type="action"
          text={I18n.t('saveChanges')}
          onClick={() => updateAccount({
            uid: account.uid,
            idType,
            id,
            firstName,
            lastName,
            displayName,
            gender,
            birthday,
            phoneNumber,
            email,
            divingLicense,
            divingExperience
          })}
        />
        { account && account.providerId === 'email' ?
          <Button type="action"
            text={I18n.t('changePassword')}
            onClick={() => changePassword(account.email)}
          /> : null
        }
      </div> : null }
    </div>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    locale: state.i18n.locale,
    account: state.global.user,
    shops: state.shop.shops,
    orders: state.order.all,
    messages: state.global.messages,
    coupons: state.discount.coupons,
    params: ownProps.match.params,
  }
}

const mapDispatchToProps = (dispatch) => ({
  navigate: (location) => dispatch(push(location)),
  updateAccount: (profile) => dispatch(updateAccount(profile)),
  changePassword: (email) => dispatch(forgotPassword(email)),
  getOrders: (creator) => dispatch(getOrders(creator)),
  getCoupons: (uid) => dispatch(getAccountCoupons(uid)),
  cancelOrder: (orderId) => dispatch(cancelOrder(orderId)),
  search: (keyword) => dispatch(search(keyword)),
  showAlert: (message, title, type, useConfirmBtn, onConfirm) =>
    dispatch(showAlert(message, title, type, useConfirmBtn, onConfirm)),
  setCurrentOrder: (order) => dispatch(setCurrentOrder(order)),
  writeComment: (comment) => dispatch(writeComment(comment)),
  removeFavorite: (payload) => dispatch(removeFavorite(payload)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Account)


// WEBPACK FOOTER //
// ./src/containers/Account/index.js